import React, { Fragment } from "react";
import PropTypes from "prop-types";
import FormFactory from "components/FormFactory";
import ImageField from "components/ImageField";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { useScrollToElement } from "utils/hooks/editor";

const SocialProfileBlock = ({ name, uid, schema }) => {
  const { values } = useFormikContext();
  useScrollToElement(name);
  const content = get(values, `${name}.data`, {});

  return (
    <Fragment>
      {content.image && (
        <ImageField name={`${name}.data.image`} image={content.image} />
      )}
      <FormFactory schema={schema} name={name} uid={uid} />
    </Fragment>
  );
};

SocialProfileBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default SocialProfileBlock;
